import { render, staticRenderFns } from "./Transactions3.vue?vue&type=template&id=19a205e9&"
import script from "./Transactions3.vue?vue&type=script&lang=ts&"
export * from "./Transactions3.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports